// frontend/src/i18n/index.js
//
// i18next initialization. All translations are bundled at startup.
// Per-module locales live inside the module directory and are imported here.
//
// HOW TO ADD TRANSLATIONS FOR A NEW MODULE:
//   1. Create frontend/src/modules/<name>/locales/ru.json and en.json
//   2. Import them below and add to the resources object
//   3. In the module's components: useTranslation('<name>')
//      where <name> is the namespace key you add in step 2
//
// LANGUAGE DETECTION ORDER:
//   1. localStorage key 'portal_lang' (user's explicit choice)
//   2. Browser language — Russian if navigator.language starts with 'ru', else English

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// ── Common (shell, navigation, shared UI) ─────────────────────────────────────
import commonRu from './locales/ru.json'
import commonEn from './locales/en.json'

// ── Module translations ───────────────────────────────────────────────────────
// Add new module imports here when creating a module.
import landingRu from '../modules/landing/locales/ru.json'
import landingEn from '../modules/landing/locales/en.json'
import quizTrainerRu from '../modules/quiz_trainer/locales/ru.json'
import quizTrainerEn from '../modules/quiz_trainer/locales/en.json'

// ── Language detection ────────────────────────────────────────────────────────
const savedLang = localStorage.getItem('portal_lang')
const browserLang = navigator.language || navigator.userLanguage || 'en'
const defaultLang = savedLang || (browserLang.startsWith('ru') ? 'ru' : 'en')

// ── Init ──────────────────────────────────────────────────────────────────────
i18n
  .use(initReactI18next)
  .init({
    lng: defaultLang,
    fallbackLng: 'en',
    ns: ['common', 'landing', 'quiz_trainer'],
    defaultNS: 'common',
    resources: {
      ru: {
        common: commonRu,
        landing: landingRu,
        quiz_trainer: quizTrainerRu,
        // Add new module namespaces: my_module: myModuleRu
      },
      en: {
        common: commonEn,
        landing: landingEn,
        quiz_trainer: quizTrainerEn,
        // Add new module namespaces: my_module: myModuleEn
      },
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  })

export default i18n
